import classNames from "classnames"
import React from "react"

export type TagProps = {
  text: string
  size?: "xs" | "sm"
  color?: "coral" | "purple" | "pink" | "blue" | "mint" | "grey" | "primary"
  disabled?: boolean
  viewClassName?: string
  textClassName?: string
}

export const Tag = ({ text, size = "sm", color = "grey", disabled, viewClassName, textClassName }: TagProps) => (
  <div
    className={classNames(
      styles.baseView,
      styles[`${size}View`],
      styles[`${color}View`],
      disabled && styles.disabledView,
      viewClassName,
    )}>
    <span
      className={classNames(styles.baseText, styles[`${size}Text`], disabled && styles.disabledText, textClassName)}>
      {text}
    </span>
  </div>
)

const styles = {
  baseView: "rounded-md whitespace-nowrap",
  baseText: "text-center align-middle capitalize text-sans text-neutral-900",
  // States
  disabledView: "bg-neutral-100",
  disabledText: "text-neutral-300",
  // Sizes
  smView: "px-2.5 pb-0.5",
  smText: "text-sm lg:text-lg",
  xsView: "px-1.5 pb-0.5",
  xsText: "text-xs",
  // Colors
  coralView: "bg-coral-50",
  purpleView: "bg-purple-100",
  pinkView: "bg-pink-100",
  blueView: "bg-blue-100",
  mintView: "bg-mint-50",
  greyView: "bg-neutral-100",
  primaryView: "bg-primary-100",
}
